import { createSlice } from "@reduxjs/toolkit";

let initialData: any = {
    licenceCriteria: null,
    selectedLicenceCriteria: null,
    licenceCriteriaStandards: null,
    criteriaActions: [],
    criteriaEvidences: [],
    standardsActions: [],
    selectedLicenceStandard: null,
    standardsEvidences: [],
    departments: null,
    criteriaComment: {
        licenceSAComment: '',
        licenceEvaluationComment: '',
    },
    selectedCommentPhase: 'SELECT_COMMENT_PHASE',
    commentContent: null,
    commentBoxTabs: [],
    selectedCommentBoxTab: null,
    criteriaCommentsHistory: null,
};


export const licence = createSlice({
    name: 'licence',
    initialState: initialData,
    reducers: {
        setLicenceCriteria: (state: any, action: any) => {
            state.licenceCriteria =  action.payload;
            return state;
        },
        setInitialLicenceCriteria: (state: any) => {
            state.licenceCriteria = initialData.licenceCriteria;
            return state;
        },
        setSelectedLicenceCriteria: (state: any, action: any) => {
            state.selectedLicenceCriteria =  action.payload;
            return state;
        },
        setInitialSelectedLicenceCriteria: (state: any) => {
            state.selectedLicenceCriteria = initialData.selectedLicenceCriteria;
            return state;
        },
        setLicenceCriteriaStandards: (state: any, action: any) => {
            state.licenceCriteriaStandards =  action.payload;
            return state;
        },
        setInitialLicenceCriteriaStandards: (state: any) => {
            state.licenceCriteriaStandards = initialData.licenceCriteriaStandards;
            return state;
        },
        setLicenceCriteriaActions: (state:any, action:any) => {
            state.criteriaActions = action.payload;
            return state;
        },
        setLicenceCriteriaEvidences: (state:any, action:any) => {
            state.criteriaEvidences = action.payload;
            return state;
        },
        setLicenceStandardsActions: (state:any, action:any) => {
            state.standardsActions = action.payload;
            return state;
        },
        setLicenceStandardsEvidences: (state:any, action:any) => {
            state.standardsEvidences = action.payload;
            return state;
        },
        setSelectedLicenceStandard: (state:any, action:any) => {
            state.selectedLicenceStandard = action.payload;
            return state;
        },
        resetSelectedLicenceStandard: (state:any) => {
            state.selectedLicenceStandard = initialData.selectedLicenceStandard;
            return state;
        },
        setDepartments: (state:any, action:any) => {
            state.departments = action.payload;
            return state;
        },
        resetDepartments: (state:any) => {
            state.departments = initialData.departments;
            return state;
        },
        setLicenceCriteriaComment: (state:any, action:any) => {
            state.criteriaComment = action.payload;
            return state;
        },
        resetLicenceCriteriaComment: (state:any) => {
            state.criteriaComment = initialData.criteriaComment;
            return state;
        },
        setSelectedLicenceCommentPhase: (state:any, action:any) => {
            state.selectedCommentPhase = action.payload;
            return state;
        },
        resetSelectedLicenceCommentPhase: (state:any) => {
            state.selectedCommentPhase = initialData.selectedCommentPhase;
            return state;
        },
        setLicenceCommentContent: (state:any, action:any) => {
            state.commentContent = action.payload;
            return state;
        },
        resetLicenceCommentContent: (state:any) => {
            state.commentContent = initialData.criteriaComment;
            return state;
        },
        setSelectedCommentBoxTab: (state:any, action:any) => {
            state.selectedCommentBoxTab = action.payload;
            return state;
        },
        resetLicence: (state:any) => {
            state = initialData;
            return state;
        },
        setCriteriaCommentsHistory: (state:any, action:any) => {
            state.criteriaCommentsHistory = action.payload;
            return state;
        },
        resetCriteriaCommentsHistory: (state:any) => {
            state.criteriaCommentsHistory = initialData.criteriaCommentsHistory;
            return state;
        },
    }
});

export const {
    setLicenceCriteria,
    setInitialLicenceCriteria,
    setSelectedLicenceCriteria,
    setInitialSelectedLicenceCriteria,
    setLicenceCriteriaStandards,
    setInitialLicenceCriteriaStandards,
    setLicenceCriteriaActions,
    setLicenceCriteriaEvidences,
    setLicenceStandardsActions,
    setLicenceStandardsEvidences,
    setSelectedLicenceStandard,
    resetSelectedLicenceStandard,
    setDepartments,
    resetDepartments,
    setLicenceCriteriaComment,
    resetLicenceCriteriaComment,
    setSelectedLicenceCommentPhase,
    resetSelectedLicenceCommentPhase,
    setLicenceCommentContent,
    resetLicenceCommentContent,
    setSelectedCommentBoxTab,
    setCriteriaCommentsHistory,
    resetCriteriaCommentsHistory,
    resetLicence
} = licence.actions;
export default licence.reducer;